<template>

    <!-- 名次并列的tooltip，入参为这个一名次的所有元素 -->
    <div style="cursor: pointer">
        <el-tooltip v-if="levelArr.length > 1" :content="levelWithArr" :placement="placement">
            <div>
                <span>{{levelArr[0].split(':')[0]}}</span>&nbsp;<span
                    :class=fontClass>{{levelArr[0].split(':')[1]}}</span><span>...</span>
            </div>
        </el-tooltip>
        <template v-else-if="levelArr.length == 0">
        </template>
        <template v-else>
            <span>{{levelArr[0].split(':')[0]}}</span>&nbsp;<span
                :class=fontClass>{{levelArr[0].split(':')[1]}}</span>
        </template>
    </div>

</template>

<script>

    export default {
        name: "tooltip4SortWith",

        props: {
            levelArr: {
                type: Array,
            },
            placement: {
                type: String,
                default: 'right',
            },
            fontClass: {
                type: String,
            }
        },

        methods: {

            //获取名次并列的元素，作为tooltip的content
            getLevelWithData(levelArr) {
                let exceptFirstArr = [...levelArr];
                // exceptFirstArr.shift();
                return exceptFirstArr.join('、');
            },

        },

        computed: {
            levelWithArr() {
                return this.getLevelWithData(this.levelArr);
            },
        },

    }
</script>

<style scoped>

</style>